/*
Note: This was originally a copy of another file: src/@/buyer-portal/components/BaseSearchProvider/utils.ts
These two files share many similarities, but they are not identical.
Eventually, the $buyer-portal version should go away, but be very careful when that happens to
ensure nothing gets broken in the pages that used to use that version of the provider (as well
as ensuring that any changes made to this version, if necessary, don't break anything that was
already using this version of the provider).
In particular, how "query" vs "filters.q" is handled is likely to require some re-work to fit
both places.

Related discussion: https://gitlab.bstock.io/b-stock/code/three-mp/fe/home-portal/-/merge_requests/514#note_435412
*/

import type { AllListingsSortByEnum } from '@b-stock/search-api-client'
import { AllListingsSortOrderEnum } from '@b-stock/search-api-client'

const sortByValues = new Set<AllListingsSortByEnum>([
  'endTime',
  'startTime',
  'winningBidAmount',
  'numberOfBids',
  'relevance',
  'recommended',
  // not yet in AllListingsSortByEnum — cast until search-api-client is updated (GLOB-4698)
  'personalization' as AllListingsSortByEnum,
])

const sortOrderValues = new Set<string>(Object.values(AllListingsSortOrderEnum))

export const validateSortBy = (
  s: string | string[] | undefined,
  fallback: AllListingsSortByEnum = 'endTime'
): AllListingsSortByEnum => {
  if (typeof s !== 'string' || !sortByValues.has(s as AllListingsSortByEnum))
    return fallback

  return s as AllListingsSortByEnum
}

export const validateSortOrder = (
  s: string | string[] | undefined,
  fallback: AllListingsSortOrderEnum = AllListingsSortOrderEnum.Asc
): AllListingsSortOrderEnum => {
  if (typeof s !== 'string' || !sortOrderValues.has(s)) return fallback

  return s as AllListingsSortOrderEnum
}
